import { forwardRef, OnInit } from '@angular/core';
import { FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { EquipmentsApi } from '@core/api/equipments/equipments.api';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import _ from 'lodash';
import { debounceTime } from 'rxjs/operators';
import english from '../../../../../main/equipments/i18n/en.json';
import spanish from '../../../../../main/equipments/i18n/es.json';
import portuguese from '../../../../../main/equipments/i18n/pt.json';
export function ValidateAutocomplete() {
    return { required: true };
}
var INPUT_FIELD_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(function () { return EquipmentTypeLegacyComponent; }),
    multi: true
};
var EquipmentTypeLegacyComponent = /** @class */ (function () {
    function EquipmentTypeLegacyComponent(fuseTranslationLoaderService, equipmentsApi) {
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.equipmentsApi = equipmentsApi;
        this.equipmentsType = [];
        this.inputValue = new FormControl();
        this.loading = false;
        this.onChange = function () { };
        this.onTouched = function () { };
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
    }
    EquipmentTypeLegacyComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.inputValue.valueChanges.pipe(debounceTime(500)).subscribe(function (value) {
            _this.equipmentsType = [];
            if (value) {
                _this.searchEquipmentsTypes({ name_contains: value });
            }
        });
    };
    EquipmentTypeLegacyComponent.prototype.searchEquipmentsTypes = function (query) {
        var _this = this;
        this.loading = true;
        this.equipmentsApi.searchEquipmentType(query).subscribe(function (result) {
            _this.loading = false;
            _this.equipmentsType = result.items;
        });
    };
    EquipmentTypeLegacyComponent.prototype.writeValue = function (equipmentTypeId) {
        var _this = this;
        if (equipmentTypeId) {
            this.equipmentsApi.searchOneEquipmentType(equipmentTypeId).subscribe(function (equipmentType) {
                _this.selectedEquipmentType = equipmentType;
                _this.hasSelectedEquipmentType = true;
                _this.inputValue.setErrors(null);
            });
        }
        else {
            this.deselectEquipmentType();
        }
    };
    EquipmentTypeLegacyComponent.prototype.registerOnChange = function (fn) {
        this.onChange = fn;
    };
    EquipmentTypeLegacyComponent.prototype.registerOnTouched = function (fn) {
        this.onTouched = fn;
    };
    EquipmentTypeLegacyComponent.prototype.setSelectedEquipmentType = function () {
        var _this = this;
        if (this.inputValue.value) {
            this.onChange(this.inputValue.value);
            this.selectedEquipmentType = _.find(this.equipmentsType, function (equipmentType) { return equipmentType.id === _this.inputValue.value; });
            this.hasSelectedEquipmentType = true;
            this.inputValue.setErrors(null);
        }
    };
    EquipmentTypeLegacyComponent.prototype.deselectEquipmentType = function () {
        this.onChange(null);
        this.inputValue.setValue(null);
        this.selectedEquipmentType = null;
        this.hasSelectedEquipmentType = false;
        this.inputValue.setErrors(null);
    };
    return EquipmentTypeLegacyComponent;
}());
export { EquipmentTypeLegacyComponent };
